// extracted by mini-css-extract-plugin
export default {"text":"tQtP5E3jc19CJp5GdBp9","color-b":"iuXZ45Wvih9l4OT1LQCG","color-c":"pG4POEjhjL9ElL018Y3D","color-d":"MAPB8jCpoBhP5zAgN33p"};